import React, { useState } from "react";
import { db } from "../firebase"; // تأكد إن عندك ملف firebase.js
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await addDoc(collection(db, "contactMessages"), {
        ...formData,
        createdAt: serverTimestamp(),
      });
      alert("✅ تم إرسال رسالتك بنجاح، سنتواصل معك قريبًا");
      setFormData({ name: "", email: "", message: "" });
    } catch (error) {
      console.error("حدث خطأ:", error);
      alert("❌ حدث خطأ أثناء الإرسال، حاول مرة أخرى.");
    }
    setLoading(false);
  };

  return (
    <section
      id="contact"
      style={{
        backgroundColor: "#f8faff",
        padding: "80px 20px",
        fontFamily: "Cairo, sans-serif",
      }}
    >
      <h2
        style={{
          textAlign: "center",
          fontSize: "2.5rem",
          color: "#004aad",
          marginBottom: "10px",
        }}
      >
        تواصل معنا
      </h2>
      <p
        style={{
          textAlign: "center",
          color: "#555",
          fontSize: "1.1rem",
          marginBottom: "50px",
        }}
      >
        نحن هنا للإجابة على استفساراتكم وتلقي مقترحاتكم — يسعدنا تواصلكم معنا دائمًا 💙
      </p>

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "40px",
          maxWidth: "1100px",
          margin: "0 auto",
          alignItems: "stretch",
          justifyContent: "center",
        }}
      >
        {/* نموذج التواصل */}
        <div
          style={{
            flex: "1 1 500px",
            background: "#fff",
            borderRadius: "20px",
            padding: "40px 30px",
            boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <h3 style={{ color: "#004aad", marginBottom: "25px" }}>
            أرسل لنا رسالة
          </h3>
          <form
            onSubmit={handleSubmit}
            style={{
              width: "100%",
              maxWidth: "400px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <input
              type="text"
              name="name"
              placeholder="الاسم الكامل"
              value={formData.name}
              onChange={handleChange}
              required
              style={inputStyle}
            />
            <input
              type="email"
              name="email"
              placeholder="البريد الإلكتروني"
              value={formData.email}
              onChange={handleChange}
              required
              style={inputStyle}
            />
            <textarea
              name="message"
              placeholder="اكتب رسالتك هنا..."
              value={formData.message}
              onChange={handleChange}
              rows="5"
              required
              style={{ ...inputStyle, height: "120px", resize: "none" }}
            />
            <button
              type="submit"
              disabled={loading}
              style={{
                backgroundColor: "#004aad",
                color: "#fff",
                border: "none",
                padding: "12px 25px",
                borderRadius: "8px",
                cursor: "pointer",
                fontSize: "1rem",
                transition: "0.3s",
                width: "100%",
                maxWidth: "400px",
                opacity: loading ? 0.7 : 1,
              }}
              onMouseEnter={(e) =>
                (e.target.style.backgroundColor = "#007bff")
              }
              onMouseLeave={(e) =>
                (e.target.style.backgroundColor = "#004aad")
              }
            >
              {loading ? "جارٍ الإرسال..." : "إرسال الرسالة"}
            </button>
          </form>
        </div>

        {/* بيانات التواصل + الخريطة */}
        <div
          style={{
            flex: "1 1 400px",
            display: "flex",
            flexDirection: "column",
            gap: "20px",
          }}
        >
          <div
            style={{
              background: "#004aad",
              color: "#fff",
              borderRadius: "20px",
              padding: "30px",
              boxShadow: "0 8px 25px rgba(0,0,0,0.1)",
            }}
          >
            <h3 style={{ marginBottom: "15px" }}>بيانات التواصل 📞</h3>
            <p style={{ margin: "8px 0" }}>
              📍 العنوان: ش سوتر - امام بوابة كلية الحقوق - الاسكندرية
            </p>
            <p style={{ margin: "8px 0" }}>📧 البريد الإلكتروني: info@iisd-eg.org</p>
            <p style={{ margin: "8px 0" }}>📱 الهاتف: 01023343014</p>
          </div>

          <div
            style={{
              borderRadius: "20px",
              overflow: "hidden",
              boxShadow: "0 8px 25px rgba(0,0,0,0.1)",
              flex: "1",
            }}
          >
            <iframe
              title="موقع المؤسسة"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3412.5051392346213!2d29.909862599999997!3d31.206731699999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14f5c38bcc6af1dd%3A0x5dc8b5381cfb48f3!2sFaculty%20of%20Law%2C%20Alexandria%20University!5e0!3m2!1sen!2seg!4v1762780872246!5m2!1sen!2seg"
              width="100%"
              height="300"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

const inputStyle = {
  width: "100%",
  padding: "12px 14px",
  marginBottom: "18px",
  borderRadius: "8px",
  border: "1px solid #ccc",
  fontSize: "1rem",
  direction: "rtl",
  outline: "none",
  textAlign: "right",
  boxSizing: "border-box",
};

export default ContactUs;